// extracted by mini-css-extract-plugin
export default {"switcher":"index-module__switcher___857064"};